import Create from './Create';
import Search from './Search';
import Filter from './Filter';
import Update from './Update';
import Delete from './Delete';
import Body   from './Body'  ;

type Props = {
  Create: typeof Create;
  Search: typeof Search;
  Filter: typeof Filter;
  Update: typeof Update;
  Delete: typeof Delete;
  Body  : typeof Body  ;
};

const NeighborhoodComponents: Props = {
  Create,
  Search,
  Filter,
  Update,
  Delete,
  Body  ,
}

export default NeighborhoodComponents;
